import { Action, Module, Mutation } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import {
  checkVerificationCode,
  queryWarrantyByMobile,
  createWarrantyFeedback
} from "@/graphql/claim.gql";
import PaginationModule from "@/store/base-modules/PaginationModule";
import type { PaginationDataState } from "@/types";

export interface OwnerClaimState extends PaginationDataState {}

@Module({ name: "OwnerClaimModule", namespaced: true })
export default class OwnerClaimModule
  extends PaginationModule<OwnerClaimState, RootState>
  implements OwnerClaimState {
  private ownerInfo: any = {};
  private ownerBuyRecord: any[] = [];
  private applyData = {};
  private applyAfterSaleInfo = {};

  @Mutation
  saveApplyAfterSaleInfoMutation(data: any) {
    this.applyAfterSaleInfo = data ?? {};
  }

  @Mutation
  saveApplyDataMutation(data: any) {
    this.applyData = data ?? {};
  }

  @Mutation
  saveOwnerInfoMutation(data: any) {
    this.ownerInfo = data ?? {};
  }

  @Mutation
  saveOwnerBuyRecordMutation(data: any) {
    this.ownerBuyRecord = data ?? [];
  }

  @Mutation
  addOwnerBuyRecordMutation(data: any[]) {
    this.ownerBuyRecord.push(...data);
  }

  // 验证车主
  @Action
  async verifyOwnerAction(variables: any) {
    return await queryRequest({
      query: checkVerificationCode,
      variables
    });
  }

  // 查询车主质保卡
  @Action
  async queryOwnerWarrantyAction(variables: any) {
    const {
      dataList = [],
      pageInfo: { totalCount }
    } = await queryRequest({
      query: queryWarrantyByMobile,
      variables
    });

    const data = dataList.map(o => o.data);

    const {
      state: { paginationData },
      commit
    } = this.context;

    commit(
      paginationData.pageNum === 1
        ? "saveOwnerBuyRecordMutation"
        : "addOwnerBuyRecordMutation",
      data
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
    // 保存车主信息
    const { ownerMobile, ownerName } = data[0]?.detailDomains[0] || {};
    commit("saveOwnerInfoMutation", {
      ownerMobile,
      ownerName
    });

    return data;
  }

  @Action
  async createWarrantyFeedbackAction(variables: any) {
    return await queryRequest({
      query: createWarrantyFeedback,
      variables
    });
  }
}
